import React from "react";

import { CustomAvatarCard } from "@components/custom";

import { Group } from "@mantine/core";

export const CustomSiderAvatarCard = () => {
  return (
    <>
      <Group>
        <CustomAvatarCard
          options={[
            {
              value: "PTO T100",
              label: "PTO T100",
              image: "https://picsum.photos/id/236/200/300",
            },
            {
              value: "test1",
              label: "Test 1",
              image: "https://picsum.photos/id/238/200/300",
            },
            {
              value: "test2",
              label: "Test 2",
              image: "https://picsum.photos/id/237/200/300",
            },
          ]}
          user={{
            name: "Chris Moore",
            role: "Superadmin",
            avatar: "https://picsum.photos/id/239/200/300",
          }}
          onImpersonate={() => console.log("Impersonate clicked")}
        />
      </Group>
    </>
  );
};
